export default {
    bannerText: state => state.bannerText
}
